import {NameSpace} from "../name-space.js";


const NAME_SPASE = NameSpace.APPLICATION;


const getActiveDataMode = (state) => {
  return state[NAME_SPASE].activeDataMode;
};

const getActivePoolId = (state) => {
  return state[NAME_SPASE].activePoolId;
};

const getActiveAreaId = (state) => {
  return state[NAME_SPASE].activeAreaId;
};

const getIsLabelLoad = (state) => {
  return state[NAME_SPASE].isLabelLoad;
};

const getActivePeriodId = (state) => {
  return state[NAME_SPASE].activePeriodId;
};


export {
  getActiveAreaId,
  getActiveDataMode,
  getActivePeriodId,
  getActivePoolId,
  getIsLabelLoad,
};
